import { FC, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useSearchParams } from "react-router-dom"
import { showToast } from "@/helpers/toast"
import { useModals } from "@/modals"
import { Loader } from "@/ui/Loader"

export const OAuthErrorRedirect: FC = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { openModal } = useModals()

  useEffect(() => {
    const error = searchParams.get("error")

    if (error === "PLAYER_NOT_FOUND") {
      openModal("authRedirectModal", { mode: "toRegister", email: "" })
      navigate("/login", { replace: true })
      return
    }

    if (error === "ACCOUNT_ALREADY_EXISTS") {
      openModal("authRedirectModal", { mode: "toLogin", email: "" })
      navigate("/register", { replace: true })
      return
    }

    showToast.error(t("errors.authFailed"))
    navigate("/login", { replace: true })
  }, [])

  return <Loader />
}
